module.exports = __webpack_public_path__ + "img/gb2.46b3f7fc.png";